// extracted by mini-css-extract-plugin
export var checkbox = "_8f-0";
export var circle = "_8f-3";
export var horizontalContainer = "_8f-7";
export var sm = "_8f-5";
export var switch0 = "_8f-2";
export var switchDisabled = "_8f-8";
export var switchEnabled = "_8f-1";
export var textSwitchContainer = "_8f-9";
export var textSwitchOption = "_8f-a";
export var textSwitchOptionSelected = "_8f-b";
export var verticalContainer = "_8f-6";
export var xs = "_8f-4";